// GeneralViews
import NotFound from 'src/pages/GeneralViews/NotFoundPage.vue'
import Login from 'src/pages/GeneralViews/Login.vue'

import templatePage from './template'
import agreementPage from './agreement'
import settingPage from './setting'

const loginPage = {
  path: '/login',
  name: 'LoginPage',
  component: Login,
}

const routes = [
  {
    path: '*',
    component: NotFound,
  },
  {
    path: '/',
    redirect: '/agreements',
  },
  loginPage,
  ...templatePage,
  agreementPage,
  settingPage,
]


export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js